import { faCcAmex, faCcDiscover, faCcMastercard, faCcPaypal, faCcStripe, faCcVisa, faFacebookSquare, faInstagramSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Footer.css';
import { Link } from 'react-router-dom';
import { ScrollTop } from '../common/ScrollTop';
import { Button, UnstyledButton } from '@mantine/core';
import logoPng from '../../assets/logoFab2.png';
import downloadApp from "../../assets/DownloadAppLogo.svg";

const Footer = ({ faqRef, contactRef }) => {
    

    const linksData = [
        {
            title: 'FabInsta', items: ['Home', 'Shop',
                // 'Woven', 'Knit', 'Non-Woven',
            ]
        },
        { title: 'Help', items: ['Contact Us', 'FAQ'] },
        {
            title: 'Terms', items: ['Terms & Conditions', 'Privacy Policy', 'Shipment Policy'
                //  'Cookies'
            ]
        },
    ];
    const handleSalesmanDownload = () => {
        const isUat = window.location.origin.includes('uat') || window.location.origin.includes('localhost');

        const url = "https://play.google.com/store/apps/details?id=com.fabinsta"
        
        const link = document.createElement('a');
        link.href = url;
        link.download = "Buyer.apk";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
       const handleSalesmanDownloadSeller = () => {
    const isUat = window.location.origin.includes('uat') || window.location.origin.includes('localhost');

    const url =  "https://play.google.com/store/apps/details?id=com.fabinstavendorapp"
     
    const link = document.createElement('a');
    link.href = url;
    link.download = "Buyer.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
    const routeMapping = {
        'Home': { to: '/home' },
        "Shop": { to: '/fabrics', state: { page: 0 } },
        'Help center': { to: '/home', state: { contactUs: true } },
        'Contact Us': { to: '/home', state: { contactUs: true } },
        'FAQ': { to: '/home', state: { faq: true } },
        'Privacy Policy': { to: '/privacy-policy', state: { privacyPolicy: true } },
          'Shipment Policy': { to: '/shipment-policy', state: { shipmentPolicy: true } },
        'Terms & Conditions': { to: '/terms-and-conditions', state: { termsOfService: true } },
    };

    // 'Woven': { to: '/fabrics', },
    // 'Knit': { to: '/fabrics?tags=Knit', },
    // 'Non-Woven': { to: '/fabrics?tags=Non-Woven', },
    return (
        <footer className="footer">
            <div className='footer-container-1'>
                <div className="footer-content">
                    <h2 className="site-title"><img src={`${logoPng}?time=${Date.now()}`}
                        alt="logo"
                        style={{
                            width: "150px",
                            marginTop: "0.5rem",
                        }} /></h2>

                    <div className="contact-info-block">
                        <p className="contact-info">
                            <strong>Head office :</strong>
                        </p>

                        <p className="contact-info">
                            Ultron Textiles LLP 25/6 & 5, S A Khader Layout Main Road,
                            Tiruppur, 641601<br />
                        </p>
                        <p className="contact-info">
                            <strong>Branch :</strong>
                        </p>
                        <p className="contact-info">
                            Ultron Textiles LLP - Surat  Plot C56-C56M, Lakshminarayan Industrial Estate,<br />
                            Udhna, Surat, Gujarat - 394210<br />
                        </p>

                        <p className="contact-info">
                            <strong>Contact :</strong> 8072004304
                        </p>

                        <p className="contact-info">
                            <strong>Email :</strong> <a href="mailto:ultrontextilesllp@gmail.com">ultrontextilesllp@gmail.com</a>
                        </p>

                        <p className="contact-info">
                            <strong>GST :</strong> 24AAHFU6343D1ZB
                        </p>

                        <p className="contact-info copyright">
                            &copy; 2024 Ultron Pvt Ltd. All rights reserved.
                        </p>
                    </div>

                </div>
                {linksData.map((linkGroup, index) => (
                    <div className="links" key={index}>
                        <h4>{linkGroup.title}</h4>
                        <ul>
                            {linkGroup.items.map((item, idx) => (
                                <li key={idx}>
                                    {routeMapping[item]?.to ? (
                                        <Link to={routeMapping[item].to} state={routeMapping[item].state || {}}>
                                            {item}
                                        </Link>
                                    ) : (
                                        <span style={{ fontWeight: 400, fontSize: '16px', color: '#333333' }}>{item}</span>
                                    )}

                                </li>
                            ))}
                        </ul>
                        {linkGroup.title === 'Terms' && <div className="card-button-down-appp">
                            <div className="card-button-down-appp" style={{ position: "relative" }}>
                                 <div className="down-app-msgg">Download Buyer app</div>
                                <div className='down-app-flex' onClick={handleSalesmanDownload} >
                                    <div className="mob-app-dow-buyerr">Buyer App</div>
                                    <img src={`${downloadApp}?time=${Date.now()}`} alt="down_appp" className="down-appp" />
                                </div>
                            </div>
                        </div>}
                           {linkGroup.title === 'Terms' && <div className="card-button-down-appp">
                            <div className="card-button-down-appp" style={{ position: "relative" }}>
                                 <div className="down-app-msgg2">Download Seller app</div>
                                <div className='down-app-flex' onClick={handleSalesmanDownloadSeller} >
                                    <div className="mob-app-dow-buyerr">Seller App</div>
                                    <img src={`${downloadApp}?time=${Date.now()}`} alt="down_appp" className="down-appp" />
                                </div>
                            </div>
                        </div>}
                    </div>
                ))}
            </div>
            <hr />
            <div className='footer-container-2'>
                <div className="social">
                    {[faFacebookSquare, faInstagramSquare, faYoutubeSquare].map((icon, index) => (
                        <FontAwesomeIcon className="social-media" icon={icon} key={index} />
                    ))}
                </div>
            </div>
            <ScrollTop />
        </footer>
    );
};

export default Footer;
